export const ALLOWED_TO_SHARE_LOCATION = 'ALLOWED_TO_SHARE_LOCATION';
